<template>
  <div class="conditions" v-if="conditions.length > 0">
    <h3>{{ $t("probableConditions") }}</h3>
    <div
      class="row no-gutters my-3 pb-3 border-bottom"
      v-for="condition in conditions"
      :key="condition.id"
    >
      <div class="col-2 pr-3 pt-1">
        <div class="progress">
          <div
            class="progress-bar progress-bar-striped"
            role="progressbar"
            :style="{
              width: `${parseInt(condition.probability * 100)}%`,
            }"
            :class="{
              'bg-success': condition.probability <= 0.33,
              'bg-warning':
                condition.probability > 0.33 && condition.probability <= 0.67,
              'bg-danger': condition.probability >= 0.67,
            }"
          ></div>
        </div>
      </div>
      <div class="col">
        <strong class="d-block">{{ condition.name[$i18n.locale] }}</strong>
      </div>
      <div class="col-12">
        <small>{{ condition.extras.hint[$i18n.locale] }}</small>
      </div>
      <div
        class="col-12"
        v-if="
          !scheduleId &&
          condition.categories.length > 0 &&
          specialityByCat(condition.categories[0])
        "
      >
        <router-link
          :to="`/doctors?speciality=${
            specialityByCat(condition.categories[0]).id
          }&interview=${interviewId}`"
          class="nounderline d-block py-2 mt-2 svg-sm svg-upper text-center shadow-sm"
        >
          <DoctorIcon></DoctorIcon>
          {{ $t("seeAll") }}
          {{ specialityByCat(condition.categories[0]).doctor_name[authLocale] }}
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import DoctorIcon from '@/components/Icons/Doctor'
export default {
  components: {
    DoctorIcon
  },
  props: {
    conditions: {
      type: Array,
      required: true
    },
    interviewId: {
      type: String,
      required: true
    },
    scheduleId: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      authLocale: 'auth/locale',
      specialityByCat: 'speciality/byInfermedicaCategory'
    })
  }
}
</script>
<i18n>
{
  "ka": {
    "probableConditions": "შესაძლო დაავადებათა ალბათობები",
    "seeAll": "შეარჩიე"
  },
  "en": {
    "probableConditions": "Probable Conditions",
    "seeAll": "See All"
  }
}
</i18n>
